import type { RegulationId } from '@dcs/content';
import { regulations, type TheoryRegulationRange } from 'virtual:theory-counts';

/**
 * The home page's "Đề hiện hành" chip without the regulation data: the date ranges come from
 * `virtual:theory-counts` (built from `@dcs/content`), so `/` loads neither `@dcs/theory-core` nor
 * `features/theory/route-params` up front. `regulation.test.ts` keeps both functions equal to the
 * ones the theory screens use (`defaultRegulation`, `todayISO`).
 */

/** `yyyy-mm-dd` of `date` in the user's time zone (the theory route's `todayISO`). */
export function localDateISO(date: Date): string {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${String(date.getFullYear())}-${month}-${day}`;
}

/**
 * The regulation set that applies on `today` (`yyyy-mm-dd`), by the rule of `defaultRegulation`
 * in `@dcs/theory-core`: both ends inclusive; outside every range the latest set that already
 * started, or the oldest one before them all. `sets` is oldest first.
 */
export function currentRegulation(
  today: string,
  sets: readonly TheoryRegulationRange[] = regulations,
): RegulationId {
  const inside = sets.find(
    (set) => set.effectiveFrom <= today && (set.effectiveTo === null || today <= set.effectiveTo),
  );
  if (inside !== undefined) return inside.id;
  const started = sets.filter((set) => set.effectiveFrom <= today);
  const fallback = started[started.length - 1] ?? sets[0];
  if (fallback === undefined) throw new Error('virtual:theory-counts lists no regulation set');
  return fallback.id;
}
